import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from '../components/Navbar/Navbar';
import Home from '../components/Home/Home/Home';
import LetsTalk from './LetsTalk/LetsTalk';
import ForBrands from './ForBrands/ForBrands';
import OurPurpose from './OurPurpose/OurPurpose';
import ForCreators from './ForCreators/ForCreators';
import Footer from '../components/Footer/Footer';
import PrivacyPolocy from './PrivacyPolicy/PrivacyPolicy';
import OurNews from './OurNews/OurNews';
import International from '../components/International/International';
import LocationRouter from '../components/LocationRouter/LocationRouter';
import './App.css';
import { TermsAndConditions } from '../components/termsAndConditions';

const ScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if device is mobile
    const isMobile =
      window.innerWidth <= 768 ||
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    if (isMobile) {
      // For mobile devices, scroll to top with smooth behavior
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      // For desktop, instant scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

// Alternative approach: Enhanced scroll to top with more mobile-specific logic
const EnhancedScrollToTopOnRouteChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      // Check if device is mobile using multiple methods
      const isMobile =
        window.innerWidth <= 768 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ) ||
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0;

      if (isMobile) {
        // Mobile-specific scroll behavior
        // First try smooth scroll
        try {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          });
        } catch (error) {
          // Fallback for older mobile browsers
          window.scrollTo(0, 0);
        }

        // Additional mobile-specific logic
        // Force scroll to top after a small delay to ensure it works
        setTimeout(() => {
          if (window.pageYOffset > 0) {
            window.scrollTo(0, 0);
          }
        }, 100);

        // For iOS Safari and other mobile browsers that might need body scroll
        if (document.body.scrollTop > 0) {
          document.body.scrollTop = 0;
        }

        // For some mobile browsers, also scroll the document element
        if (document.documentElement.scrollTop > 0) {
          document.documentElement.scrollTop = 0;
        }
      } else {
        // Desktop behavior - instant scroll
        window.scrollTo(0, 0);
      }
    };

    // Execute scroll to top
    scrollToTop();

    // Also add a resize listener to handle orientation changes on mobile
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        scrollToTop();
      }
    };

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      {/* Use the enhanced version for better mobile support */}
      <EnhancedScrollToTopOnRouteChange />
      <div className="App">
        <Navbar />

        {/* Main content area - each route component handles its own containers */}
        <main>
          <Routes>
            <Route path="/" element={<LocationRouter />} />
            <Route path="/international" element={<International />} />
            <Route path="/for-creators" element={<ForCreators />} />
            <Route path="/for-brands" element={<ForBrands />} />
            <Route path="/our-purpose" element={<OurPurpose />} />
            <Route path="/lets-talk" element={<LetsTalk />} />
            <Route path="/privacy-policy" element={<PrivacyPolocy />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditions />}
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>

        {/* Footer with full-width background but contained content */}
        <div className="footer-app">
          <div className="container">
            <Footer />
          </div>
        </div>
      </div>

      {/* Toast Notifications */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Router>
  );
};

export default App;
